export const NOTIFICATION_DAYS_ALERT = 5

export const CONTACT_EMAIL = 'enmanuelmag@cardor.dev'
